module.exports = __webpack_public_path__ + "static/media/20.4ad3d255.svg";